
import internal from "stream";
import { ApiOldBaseHelper } from "./ApiOldBaseHelper";
import { VovClient, GetDiariesForUserDTO, AuthRequest, GetDailyRecordsForUserDTO, GetWeatherForRecordDTO, GetWorkerForRecordDTO, AuthOldErpAdminUsersRequest, GetDailyFullRecordResponse, GetDailyRecordsForUserAndDiaryResponse, FileParameter, FileResponse, SaveWorkersRequest, SaveWorkerReqDTO, SaveDiaryContentsRequest, SaveWeatherReqDTO, SaveWeathersRequest, GetDownloadForSignedDiaryRequest, CreateDailyRecordRequest, SaveDiarySignatureAdminUserResponse, AddImageToProjectAndDiaryRecordResponse, SaveMaterialsTableReqDTO, SaveMaterialsTableRequest, SaveMachinesTableReqDTO, SaveMachinesTableRequest, GetMaterialsForRecordTableDTO, GetMachinesForRecordTableDTO, GetDiaryDataDetailResponse, BuildingDTO, CreateDiaryRequest, SaveDiaryRequest, DeleteDiariesRequest, DeleteDailyRecordRequest, GetDailyRecordsForUserAndDiaryByRecordIdResponse, GroupAdminDTO, ImageDiaryDTO, GetTodosForDiaryDTO, FileToTransferDTO, TransferPhotosFromProjectRequest, GetDiarySearchResultRequest, DailyRecordSearchDTO, CopyDiaryRecordRequest, LockDiaryRecordRequest, SignatureDTO, GetSignaturesForRecordResponse, FileDiaryDTO, FileDirectoryDTO, AddRemoveFileDiaryRecordDTO, AddRemoveFilesDiaryRecordRequest, AddRemoveFilesDiaryRecordResponse, UploadFileToDiaryDirectResponse, GetDiaryPermissionsResponse, DeleteFileRelationDiaryRequest, GetDiaryRecordDataNotTablesResponse, InvestorsChatMessageDTO, PostDiaryChatMessageInvestorsRequest, SaveDiaryContentsResponse, GetWeatherForRecordRequest, GetWorkersForRecordRequest, GetMaterialsForRecordTableRequest, GetMachinesForRecordTableRequest, GetDailyFullRecordRequest, AuthOldErpAdminUsersResponse, AuthResponse, MoveDiariesFromTrashRequest, MoveDialyRecordsFromTrashRequest, EmployeeGroupDTO, SaveRotatedImageRequest, SaveRotatedImageResponse, UploadDigitalSignedPDFResponse, EmployeeInGroupDTO, AddEmployeesToWorkersRequest, SendMessageDiaryRequest, WealthForDiaryDialogDTO, AddWealthsToMechanismsRequest, GetBuildingWeatherByDiaryIdRequest, GetBuildingWeatherByDiaryIdResponse, SaveBuildingWeatherToDiaryDiaryByIdRequest, GetPhotosFromBuildingToDiaryChooseResponse, AuthEmpToAdminUserRequest, UserGroupDTO, AddEmployeesToWorkersResponse, AddWealthsToMechanismsResponse, SubcontractorsChatMessageDTO, PostDiaryChatMessageSubcontractorsRequest, ChatGroupDTO, CreateSubcontractorUserRequest, DiaryLogDTO, CreateSubcontractorUserResponse, UsersGroupDiaryDTO, GetMaterialsForRecordsExcelRequest, UserIdAndNameDTO, GetPrintStatusResponse, GetUserIdRequest, GetUserIdResponse, ResetPasswordResponse, ResetPasswordRequest, AdminUsersDTO, UserRoleDTO, GetUsersAndEmployeesIdsAndNamesResponse, AdminUserDTO, EmailTemplateDTO, GetPrintDiaryInDateRangeRequest, GetSignInformationsForSigniWorkflowResponse, StartSigniInteractiveRequest, DiaryPrintType, PrintDiaryBackgroundRequest, GetPrintStatusRequest, PrintSignedDiaryRecordsZIPRequest, GetImagesUrlsForRecordResponse, CreateOrUpdatePromptRequest, CreateOrUpdatePromptResponse, PromptDTO, PromptType, DeletePromptRequest, DeletePromptResponse, UserDTO, EmployeeDTO, DiaryListDTO, MoveTodosFromThrashRequest, EmployeeListDTO, SetIsEmployeeActiveRequest, EmployeeDeletedDTO, MoveEmployeesFromTrashRequest, DeleteEmployeesRequest, PreviousMessagesDTO, SendGptMessageRequest, SendGptImageMessageRequest, GetImagesBuildingResponse, SetIsActiveDiaryRequest } from "./ApiServerVov";

export class APIVovHelper extends ApiOldBaseHelper {

    public async Login(appUri: string, email: string, password: string): Promise<AuthResponse> {
        let t = (await this.GetClientToAuth().auth(new AuthRequest({
            application: appUri,
            adminUsername: email, password: password
        })));
        localStorage.setItem('old_bearer', t.token!);
        localStorage.setItem('old_refresh_token', t.refreshToken!);
        localStorage.setItem('old_app_uri', appUri);
        console.log(t);
        return t;
    }
    public async LoginErp(token: string, adminUserId: number, domain: string): Promise<AuthOldErpAdminUsersResponse> {
        let t = (await this.GetClientToAuth().loginOldErp(new AuthOldErpAdminUsersRequest({ adminUserId: adminUserId, token: token })));
        localStorage.setItem('old_bearer', t.token!);
        localStorage.setItem('old_app_uri', domain);
        console.log(t);
        return t;
    }
    public async LoginEmpAsAdmin(token: string, adminUserId: number, employeeId: number, domain: string): Promise<AuthOldErpAdminUsersResponse> {
        let t = (await this.GetClientToAuth().loginEmpAsAdminMobile(new AuthEmpToAdminUserRequest({ adminUsersId: adminUserId, employeeToken: token, employeeId: employeeId })));
        localStorage.setItem('old_bearer', t.token!);
        localStorage.setItem('old_app_uri', domain);
        console.log(t);
        return t;
    }
    // public async GetBase64FromUri(uri: string): Promise<string | undefined> {
    //     return (await this.GetAdressedAuthRefreshableClient().getBase64FromUri(new GetBase64ForImageRequest({ uri: uri }))).base64;
    // }

    public async GetUser(): Promise<GetUserIdResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getUserId(new GetUserIdRequest()));
    }

    public async GetDiaryPermissions(): Promise<GetDiaryPermissionsResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getDiaryPermissions());
    }
    public async GetCompanyNameForDiary(): Promise<string> {
        return (await this.GetAdressedAuthRefreshableClient().getCompanyNameForDiary()).companyName!;
    }
    public async GetDiaries(deleted: boolean, onlyMain: boolean, buildingId?: number): Promise<GetDiariesForUserDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDiariesForUser(deleted, onlyMain, buildingId ? buildingId : 0)).diaries!;
    }
    public async GetDiaryRecords(deleted: boolean): Promise<GetDailyRecordsForUserDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDailyRecordsForUser(deleted)).diaries!;
    }
    public async GetWeatherForRecord(recordId: number, onlyShared: boolean): Promise<GetWeatherForRecordDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getWeatherForRecord(new GetWeatherForRecordRequest({
            diaryRecordId: recordId,
            onlyShared: onlyShared,
            onlyMine: false,
        }))).weathers!;
    }
    public async GetWorkersForRecord(recordId: number, onlyShared: boolean): Promise<GetWorkerForRecordDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getWorkersForRecord(new GetWorkersForRecordRequest({
            diaryRecordId: recordId,
            onlyShared: onlyShared,
            onlyMine: false,
        }))).workers!;
    }
    public async GetMaterialsForRecord(recordId: number, onlyShared: boolean): Promise<GetMaterialsForRecordTableDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getMaterialsForRecordTable(new GetMaterialsForRecordTableRequest({
            diaryRecordId: recordId,
            onlyShared: onlyShared,
            onlyMine: false,
        }))).materials!;
    }
    public async GetMachinesForRecordTable(recordId: number, onlyShared: boolean): Promise<GetMachinesForRecordTableDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getMachinesForRecordTable(new GetMachinesForRecordTableRequest({
            diaryRecordId: recordId,
            onlyShared: onlyShared,
            onlyMine: false,
        }))).machines!;
    }
    public async GetCompletedWorksRecord(recordId: number): Promise<string | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getCompletedWorks(recordId)).completedWorks;
    }
    public async GetImagesForRecord(recordId: number): Promise<GetImagesUrlsForRecordResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getDiaryImages(recordId, false));
    }
    public async GetSignaturesForRecord(recordId: number): Promise<GetSignaturesForRecordResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getSignaturesForRecord(recordId, false));
    }
    public async GetAttachmentsForRecord(recordId: number): Promise<FileDiaryDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getFilesForDiary(recordId)).files;
    }
    public async GetTodosForRecord(recordId: number): Promise<GetTodosForDiaryDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getTodosForDiary(recordId)).todos;
    }
    public async TransferPhotosFromProject(recordId: number, images: FileToTransferDTO[]): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().transferPhotoFromProject(new TransferPhotosFromProjectRequest({
            diaryRecordId: recordId,
            filenames: images
        }))).ok;
    }
    public async GetFilesFromProject(recordId: number): Promise<FileDirectoryDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getFilesFromBuildingForDiary(recordId)).files;
    }
    public async GetInvestorsChatMessages(recordId: number): Promise<InvestorsChatMessageDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getInvestorsChatMessages(recordId)).messages;
    }
    public async GetSubcontractorsChatMessages(recordId: number): Promise<ChatGroupDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getSubcontractorsChatMessages(recordId)).groups;
    }
    public async SaveShownChatMessages(recordId: number): Promise<boolean> {
        return (await this.GetAdressedAuthRefreshableClient().saveShownChat(recordId)).ok!;
    }
    public async PostInvestorsMessage(recordId: number, message: string): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().sendInvestorsChatMessage(new PostDiaryChatMessageInvestorsRequest({
            diaryRecordId: recordId,
            text: message
        }))).ok;
    }

    public async PostSubcontractorsMessage(recordId: number, message: string): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().sendSubcontractorsChatMessage(new PostDiaryChatMessageSubcontractorsRequest({
            diaryRecordId: recordId,
            text: message
        }))).ok;
    }

    public async GetFullDailyRecord(recordId: number, domain: string, base64: boolean, sharedOnly: boolean, onlyMine?: boolean, subcontractorId?: number): Promise<GetDailyFullRecordResponse> {
        // console.log(sharedOnly);
        return (await this.GetAdressedAuthRefreshableClient().fullDayRecord(
            new GetDailyFullRecordRequest({
                diaryRecordId: recordId,
                domain: domain,
                getBase64Images: base64,
                onlyShared: sharedOnly,
                onlyMine: onlyMine !== undefined && onlyMine === true,
                subcontractorId: subcontractorId
            })));
    }
    public async GetFullDailyRecordNotTables(recordId: number, sharedOnly: boolean): Promise<GetDiaryRecordDataNotTablesResponse> {
        return (await this.GetAdressedAuthRefreshableClient().diaryRecordDataNotTables(recordId, sharedOnly));
    }
    public async GetRecordsForViewing(recordId: number): Promise<GetDailyRecordsForUserAndDiaryResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getDailyRecordsForUserAndDiary(recordId));
    }
    public async PrintDiaryRecord(diaryRecordId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, otherUserId: number, hasPhotos: boolean): Promise<FileResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printDiaryRecord(diaryRecordId, onlyMyNotes, hasDigitalSignatureField, otherUserId, hasPhotos));
    }
    public async PrintTitlePage(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasAttachments: boolean, otherUserId: number): Promise<FileResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printDiaryTitlePage(diaryId, onlyMyNotes, hasDigitalSignatureField, hasAttachments, otherUserId));
    }
    public async PrintDiary(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasAttachments: boolean, otherUserId: number, hasPhotos: boolean): Promise<FileResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printDiary(diaryId, onlyMyNotes, hasDigitalSignatureField, hasAttachments, otherUserId, hasPhotos));
    }
    public async PrintSignedDiaryRecordsZIP(diaryId: number): Promise<void> {
        return (await this.GetAdressedAuthRefreshableClient().printSignedDiaryRecordsZIP(new PrintSignedDiaryRecordsZIPRequest({ diaryId: diaryId, apiAdress: '' })));
    }

    public async PrintDiaryInDateRange(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasAttachments: boolean, dateFrom: Date, dateTo: Date, otherUserId: number, hasPhotos: boolean): Promise<FileResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printDiaryInDateRange(new GetPrintDiaryInDateRangeRequest({ dateFrom: dateFrom, dateTo: dateTo, diaryId: diaryId, hasAttachments: hasAttachments, hasDigitalSignatureField: hasDigitalSignatureField, onlyMyNotes: onlyMyNotes, otherUserId: otherUserId, hasPhotos: hasPhotos })));
    }

    public async PrintDiaryInDateRangeBackground(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasAttachments: boolean, dateFrom: Date, dateTo: Date, hasPhotos: boolean): Promise<void> {
        return (await this.GetAdressedAuthRefreshableClient().printDiaryBackground(new PrintDiaryBackgroundRequest({ dateFrom: dateFrom, dateTo: dateTo, diaryId: diaryId, hasAttachments: hasAttachments, hasDigitalSignatureField: hasDigitalSignatureField, onlyMyNotes: onlyMyNotes, printType: DiaryPrintType.DiaryInRange, hasPhotos: hasPhotos })));
    }

    public async GetPrintStatus(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasAttachments: boolean): Promise<GetPrintStatusResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getPrintStatus(new GetPrintStatusRequest({ diaryId: diaryId, onlyMyNotes: onlyMyNotes, hasDigitalSignatureField: hasDigitalSignatureField, hasAttachments: hasAttachments })));
    }
    public async PrintWholeDiary(diaryId: number, onlyMyNotes: boolean): Promise<string | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printWholeDiary(diaryId, onlyMyNotes)).downloadUri;
    }
    public async PrintWholeDiaryInDateRange(diaryId: number, onlyMyNotes: boolean, dateFrom: string, dateTo: string): Promise<string | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printWholeDiaryInDateRange(diaryId, onlyMyNotes, dateFrom, dateTo)).downloadUri;
    }
    public async GetRecordsForViewingStateless(recordId: number): Promise<GetDailyRecordsForUserAndDiaryByRecordIdResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getDailyRecordsForUserAndDiaryByRecordId(recordId));
    }
    public async UploadPdfFileForSignature(file: FileParameter, diaryIdRecord: number, lang: string, token: string, adminId: number, domain: string): Promise<FileResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getOneDayPDF(diaryIdRecord, lang, token, adminId, domain, file));
    }
    public async UploadPdfFileForSignatureLogged(file: FileParameter, diaryIdRecord: number): Promise<FileResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getOneDayPDFLogged(diaryIdRecord, file));
    }
    public async UploadSignature(file: FileParameter, diaryIdRecord: number, isInvestor: boolean): Promise<SaveDiarySignatureAdminUserResponse> {
        return (await this.GetAdressedAuthRefreshableClient().uploadSignature(diaryIdRecord, file, isInvestor));
    }
    public async DownloadFile(file: string): Promise<FileResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getDownloadLinkOldErp(new GetDownloadForSignedDiaryRequest({ url: file })));
    }
    public async saveWorkers(diaryRecordId: number, workers: SaveWorkerReqDTO[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().saveWorkers(new SaveWorkersRequest({ diaryId: diaryRecordId, workers: workers }))).ok!);
    }
    public async saveMachines(diaryRecordId: number, machines: SaveMachinesTableReqDTO[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().saveMachinesTable(new SaveMachinesTableRequest({ diaryId: diaryRecordId, machines: machines }))).ok!);
    }
    public async saveMaterials(diaryRecordId: number, materials: SaveMaterialsTableReqDTO[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().saveMaterialsTable(new SaveMaterialsTableRequest({ diaryId: diaryRecordId, materials: materials }))).ok!);
    }
    public async saveWeathers(diaryRecordId: number, weathers: SaveWeatherReqDTO[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().saveWeathers(new SaveWeathersRequest({ diaryId: diaryRecordId, weathers: weathers }))).ok!);
    }
    public async deleteDiaryImageRel(diaryRecordId: number, imageName: string): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().deleteImageRelation(diaryRecordId, imageName)).ok!);
    }
    public async deleteRecordFileRel(diaryRecordId: number, fileId: number): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().deleteFileRel(new DeleteFileRelationDiaryRequest({ diaryRecordsId: diaryRecordId, fileId: fileId }))).ok!);
    }
    public async deleteDiaries(diaryIds: number[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().deleteDiaries(new DeleteDiariesRequest({ diaryIds: diaryIds }))).ok!);
    }
    public async deleteDiaryRecords(recordsIds: number[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().deleteDiaryRecords(new DeleteDailyRecordRequest({ diaryRecordsIds: recordsIds }))).ok!);
    }
    public async createDiaryRecord(diaryId: number, date: Date): Promise<number | string> {
        let data = (await this.GetAdressedAuthRefreshableClient().createDiaryRecord(new CreateDailyRecordRequest({ date: date, diaryId: diaryId })));
        if (data.newId)
            return data.newId;
        else return data.error!;
    }
    public async copyDiaryRecord(diaryId: number, dateFrom: Date, dateTo: Date, onlyWorkDays: boolean, completedWork: string, mach: SaveMachinesTableReqDTO[], mat: SaveMaterialsTableReqDTO[], works: SaveWorkerReqDTO[]): Promise<boolean> {
        let data = (await this.GetAdressedAuthRefreshableClient().copyDiaryRecord(new CopyDiaryRecordRequest({ diaryId: diaryId, dateFrom: dateFrom, dateTo: dateTo, onlyWorkDays: onlyWorkDays, completedWorks: completedWork, machines: mach, materials: mat, workers: works })));
        return data.ok!;
    }
    public async addImageToDiary(diaryRecordId: number, file: FileParameter): Promise<AddImageToProjectAndDiaryRecordResponse> {
        let data = (await this.GetAdressedAuthRefreshableClient().uploadImage(diaryRecordId, file));
        return data;
    }
    public async addFileToDiary(diaryRecordId: number, file: FileParameter): Promise<UploadFileToDiaryDirectResponse> {
        let data = (await this.GetAdressedAuthRefreshableClient().addFileToRecordDirect(diaryRecordId, file));
        return data;
    }
    public async addRemoveFileToDiaryRecord(diaryRecordId: number, files: AddRemoveFileDiaryRecordDTO[]): Promise<boolean | undefined> {
        let data = (await this.GetAdressedAuthRefreshableClient().addRemoveFilesDiaryRecord(new AddRemoveFilesDiaryRecordRequest({ diaryRecordId: diaryRecordId, files: files })));
        return data.ok;
    }
    public async getPhotosBuildingToChoose(diaryRecordId: number): Promise<GetPhotosFromBuildingToDiaryChooseResponse> {
        let data = (await this.GetAdressedAuthRefreshableClient().getPhotosBuildingToChoose(diaryRecordId, false));
        return data;
    }
    public async saveDiaryContents(diaryRecordId: number, stamp: number, works?: string | undefined,
        machines?: string | undefined, materials?: string | undefined, notes?: string | undefined, contents?: GroupAdminDTO[] | undefined): Promise<SaveDiaryContentsResponse> {
        return ((await this.GetAdressedAuthRefreshableClient().saveDiaryContents(
            new SaveDiaryContentsRequest({
                completedWorks: works, completedWorksLastUpdate: stamp, diaryId: diaryRecordId,
                machines: machines, materials: materials, additionalNotes: notes,
                contents: contents
            }))));
    }
    public async lockUnlockDiaryRecord(diaryRecordId: number, locked: boolean): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().lockUnlockDiaryRecord(
            new LockDiaryRecordRequest({ diaryRecordId: diaryRecordId, lock: locked }))).ok!);
    }
    public async GetDiaryDataDetail(diaryId: number): Promise<GetDiaryDataDetailResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getDiaryDataDetail(diaryId))!;
    }
    public async GetBuildingsForAdminUser(): Promise<BuildingDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().buildings()).buildings!;
    }

    public async GetUsersAndEmployeesIdsAndNames(): Promise<GetUsersAndEmployeesIdsAndNamesResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getUsersAndEmployeesIdsAndNames());
    }
    public async CreateDiary(req: Partial<GetDiaryDataDetailResponse>): Promise<number> {
        return (await this.GetAdressedAuthRefreshableClient().createDiary(new CreateDiaryRequest({
            authorWatch: req.authorWatch,
            buildingId: req.buildingId,
            city: req.city,
            constructionContractor: req.constructionContractor,
            constructionManager: req.constructionManager,
            diaryName: req.diaryName,
            district: req.district,
            generalArchitect: req.generalArchitect,
            generalContractor: req.generalContractor,
            investor: req.investor,
            place: req.place,
            projectManager: req.projectManager,
            responsibleArchitect: req.responsibleArchitect,
            responsibleCompany: req.responsibleCompany,
            section: req.section,
            subcontractors: req.subcontractors,
            tdsPermament: req.tdsPermament,
            tdsTemporary: req.tdsTemporary,
            technologicallContractor: req.technologicallContractor,
            groupId: req.groupId,
            parentDiaryId: req.parentDiaryId,
            authorizedPerson: req.authorizedPerson,
            isActive: req.isActive
        }))).diaryId!;
    }
    public async SaveDiary(req: Partial<GetDiaryDataDetailResponse>): Promise<boolean> {
        return (await this.GetAdressedAuthRefreshableClient().saveDiary(new SaveDiaryRequest({
            id: req.id,
            authorWatch: req.authorWatch,
            buildingId: req.buildingId,
            city: req.city,
            constructionContractor: req.constructionContractor,
            constructionManager: req.constructionManager,
            diaryName: req.diaryName,
            district: req.district,
            generalArchitect: req.generalArchitect,
            generalContractor: req.generalContractor,
            investor: req.investor,
            place: req.place,
            projectManager: req.projectManager,
            responsibleArchitect: req.responsibleArchitect,
            responsibleCompany: req.responsibleCompany,
            section: req.section,
            subcontractors: req.subcontractors,
            tdsPermament: req.tdsPermament,
            tdsTemporary: req.tdsTemporary,
            technologicallContractor: req.technologicallContractor,
            groupId: req.groupId,
            parentDiaryId: req.parentDiaryId,
            users: req.users,
            authorizedPerson: req.authorizedPerson,
            isActive: req.isActive
        }))).ok!;
    }

    public async GetDiarySearchResult(diarId: number | undefined, sText: string, datFrom: Date | undefined, datTo: Date | undefined): Promise<DailyRecordSearchDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDiarySearchResult(new GetDiarySearchResultRequest({ diaryId: diarId, searchText: sText, dateFrom: datFrom, dateTo: datTo }))).records!;
    }
    public async MoveDiariesFromTrash(diariesIds: number[]): Promise<boolean> {
        return (await this.GetAdressedAuthRefreshableClient().moveDiariesFromTrash(new MoveDiariesFromTrashRequest({ deletedDiariesIds: diariesIds }))).ok!;
    }
    public async MoveDailyRecordsFromTrash(recordsIds: number[]): Promise<boolean> {
        return (await this.GetAdressedAuthRefreshableClient().moveDailyRecordsFromTrash(new MoveDialyRecordsFromTrashRequest({ deletedDailyRecordsIds: recordsIds }))).ok!;
    }
    public async GetEmployeesWithGroups(diaryRecordId: number): Promise<EmployeeGroupDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getEmployeesWithGroups(diaryRecordId)).employeesWithGroups;
    }
    public async UploadDigitallySignedPDF(file: FileParameter, diaryIdRecord: number): Promise<UploadDigitalSignedPDFResponse> {
        return (await this.GetAdressedAuthRefreshableClient().uploadDigitallySignedPDF(diaryIdRecord, file));
    }
    public async SaveRotatedImageToDiary(diaryRecordId: number, imagePath: string, rotation: number): Promise<SaveRotatedImageResponse> {
        return (await this.GetAdressedAuthRefreshableClient().saveRotatedImage(new SaveRotatedImageRequest({ buildingDiaryRecordId: diaryRecordId, rotation: rotation, uri: imagePath })));
    }
    public async AddEmpsToDiary(diaryRecordId: number, emps: EmployeeInGroupDTO[]): Promise<AddEmployeesToWorkersResponse> {
        return (await this.GetAdressedAuthRefreshableClient().addEmployeesToWorkers(new AddEmployeesToWorkersRequest({ diaryRecordsId: diaryRecordId, employees: emps })));
    }
    public async RingOthersDiary(diaryRecordId: number): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().sendMessageDiary(new SendMessageDiaryRequest({ diaryRecordId: diaryRecordId }))).ok;
    }
    public async GetWeatherFromBuildingForRecord(diaryRecordId: number, hour: number, date: Date): Promise<GetBuildingWeatherByDiaryIdResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getWeatherForDiaryRecord(new GetBuildingWeatherByDiaryIdRequest({ dairyRecordId: diaryRecordId, date: date, hour: hour })));
    }
    public async SaveWeatherFromBuildingForRecord(diaryRecordId: number, hour: number, date: Date): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().saveWeatherToDiaryRecord(new SaveBuildingWeatherToDiaryDiaryByIdRequest({ dairyRecordId: diaryRecordId, date: date, hour: hour }))).ok;
    }
    public async GetWealthsForDiaryDialog(diaryRecordId: number): Promise<WealthForDiaryDialogDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getWealthsForDiaryDialog(diaryRecordId)).wealthsForDiaryDialog;
    }
    public async AddWealthsToMechanisms(diaryRecordId: number, checkedWealthsIds: number[]): Promise<AddWealthsToMechanismsResponse> {
        return (await this.GetAdressedAuthRefreshableClient().addWealthsToMechanisms(new AddWealthsToMechanismsRequest({ diaryRecordsId: diaryRecordId, checkedWealthsIds: checkedWealthsIds })));
    }

    public async UserGroups(): Promise<UserGroupDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().userGroups()).groups!;
    }

    public async CreateSubcontractorUser(name: string, email: string, groupId: number | undefined, diaryId?: number, roleId?: number): Promise<CreateSubcontractorUserResponse> {
        return (await this.GetAdressedAuthRefreshableClient().createSubcontractorUser(new CreateSubcontractorUserRequest({ name: name, email: email, groupId: groupId, diaryId: diaryId, roleId: roleId })));
    }

    public async GetDiaryRecordLog(recordId: number): Promise<DiaryLogDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDiaryRecordLog(recordId)).logs!;
    }

    public async GetDiaryUsersForGroup(groupId: number, buildingId: number): Promise<UsersGroupDiaryDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDiaryUsersForGroup(groupId, buildingId)).users!;
    }

    public async GetMaterialsForRecordsExcel(diaryId: number, start: Date, end: Date): Promise<GetMaterialsForRecordTableDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getMaterialsForRecordsExcel(new GetMaterialsForRecordsExcelRequest({ diaryId: diaryId, start: start, end: end }))).materials!;
    }

    public async ResetPassword(domain: string, email: string): Promise<ResetPasswordResponse> {
        return (await this.GetAdressedAuthRefreshableClient().resetPassword(new ResetPasswordRequest({ domain: domain, email: email })));
    }

    public async GetUserRoleForSubcontractor(): Promise<UserRoleDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getUserRoleForSubcontractor()).roles!;
    }
    public async GetUsersForSignFlow(diaryRecordId: number, lang: string): Promise<GetSignInformationsForSigniWorkflowResponse> {
        // if(this._isSubdodavatel === false)
        return (await this.GetAdressedAuthRefreshableClient().getSignPublicInformationsForSigniWorkflow(diaryRecordId, lang));
    }
    public async StartSigniInteractive(diaryRecordId: number): Promise<void> {
        // if(this._isSubdodavatel === false)
        return (await this.GetAdressedAuthRefreshableClient().startSigniInteractive(new StartSigniInteractiveRequest({
            diaryRecordId: diaryRecordId
        })));
    }

    public async PrintDiaryBackground(printType: DiaryPrintType, diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasAttachments: boolean, dateFrom: Date | undefined, dateTo: Date | undefined, hasPhotos: boolean): Promise<void> {
        return (await this.GetAdressedAuthRefreshableClient().printDiaryBackground(new PrintDiaryBackgroundRequest({
            printType: printType,
            diaryId: diaryId,
            onlyMyNotes: onlyMyNotes,
            hasDigitalSignatureField: hasDigitalSignatureField,
            hasAttachments: hasAttachments,
            dateFrom: dateFrom,
            dateTo: dateTo,
            apiAdress: "",
            hasPhotos: hasPhotos
        })));
    }
    public async CreateOrUpdatePrompt(prompt: PromptDTO, type: PromptType, relationId: number): Promise<CreateOrUpdatePromptResponse> {
        // if(this._isSubdodavatel === false)
        return (await this.GetAdressedAuthRefreshableClient().createOrUpdatePrompt(new CreateOrUpdatePromptRequest({
            id: prompt.id,
            name: prompt.name,
            text: prompt.text,
            type: type,
            realationId: relationId
        })));
    }
    public async DeletePrompt(promptId: number): Promise<DeletePromptResponse> {
        return (await this.GetAdressedAuthRefreshableClient().deletePrompt(new DeletePromptRequest({
            promptId: promptId
        })));
    }

    public async GetUsersForDiaryPrint(diaryId: number): Promise<UserDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getUsersForDiaryPrint(diaryId)).users;
    }

    public async GetApplicationUsers(): Promise<AdminUserDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getApplicationUsers()).users!;
    }

    public async GetApplicationInvestors(): Promise<AdminUserDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getApplicationInvestors()).investors!;
    }

    public async GetEmailTemplates(): Promise<EmailTemplateDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getEmailTemplates()).templates!;
    }

    public async GetEmployeeForBuilding(): Promise<EmployeeDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getEmployeeForBuilding()).employees!;
    }

    public async GetImagesBuilding(buildingId: number): Promise<GetImagesBuildingResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getImagesBuilding(buildingId));
    }

    public async GetDiariesForBuilding(buildingId: number): Promise<DiaryListDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDiariesForBuilding(buildingId)).diaries!;
    }

    public async GetDeletedTodos(): Promise<DiaryListDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDeletedTodos()).todos!;
    }

    public async MoveTodosFromThrash(ids: number[]): Promise<boolean> {
        return (await this.GetAdressedAuthRefreshableClient().moveTodosFromThrash(new MoveTodosFromThrashRequest({ deletedTodoIds: ids }))).ok!;
    }


    public async SendGptMessage(message: string, previousMessages: PreviousMessagesDTO[]): Promise<string | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().gptMessage(new SendGptMessageRequest({ message: message, previousMessages: previousMessages }))).message;
    }
    public async SendGptImage(message: string, images: string[], previousMessages: PreviousMessagesDTO[], recordId: number): Promise<string | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().gptImage(new SendGptImageMessageRequest({ message: message, imageUrls: images, previousMessages: previousMessages, diaryRecordId: recordId }))).message;
    }


    public async SetIsActiveDiary(diaryId: number, active: boolean): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().setIsActiveDiary(new SetIsActiveDiaryRequest({ diaryId: diaryId, active: active }))).ok;
    }
}